<template>
	<div class="join_page">
		<div class="jp_pc" v-if="!isPhone">
			<div class="jp_box">
				<div class="jp_con">
					<p class="jp_tit" data-aos="fade-up">招商加盟</p>
					<p class="jp_tit2" data-aos="fade-up">
						{ <span>与我们一起创造美好的未来</span> }
					</p>
					<div class="ins_box" data-aos="fade-up">
						<p class="ins_tit">剑南春专卖店申请须知：</p>
						<ul class="ins_ul flex1">
							<li class="ins_li flex1">
								<div class="ins_li_left">1</div>
								<div class="ins_li_right">
									<p class="lit_p1">投资咨询</p>
									<p class="lit_p2">
										加盟者可以通过电话、微信留言、填写申请表等方式向总部初步了解项目信息。
									</p>
								</div>
							</li>
							<li class="ins_li flex1">
								<div class="ins_li_left">2</div>
								<div class="ins_li_right">
									<p class="lit_p1">
										专卖店试销经销商资质审核
									</p>
									<p class="lit_p2">
										总部对加盟者进行审核，确认加盟者的试销合作资格。
									</p>
								</div>
							</li>
							<li class="ins_li flex1">
								<div class="ins_li_left">3</div>
								<div class="ins_li_right">
									<p class="lit_p1">专卖店试销合同签订</p>
									<p class="lit_p2">
										双方确认考察无争议，签订专卖店试销合同。
									</p>
								</div>
							</li>
							<li class="ins_li flex1">
								<div class="ins_li_left">4</div>
								<div class="ins_li_right">
									<p class="lit_p1">销售考核</p>
									<p class="lit_p2">
										试销客户将接受为期 3-9 个月的销售考核。
									</p>
								</div>
							</li>
							<li class="ins_li flex1">
								<div class="ins_li_left">5</div>
								<div class="ins_li_right">
									<p class="lit_p1">资质评估</p>
									<p class="lit_p2">
										根据试销客户销售情况，审核专卖店经销商合作资格。
									</p>
								</div>
							</li>
							<li class="ins_li flex1">
								<div class="ins_li_left">6</div>
								<div class="ins_li_right">
									<p class="lit_p1">签订专卖店合同</p>
									<p class="lit_p2">
										双方确认考察结果无争议，正式签订专卖店合同。
									</p>
								</div>
							</li>
							<li class="ins_li flex1">
								<div class="ins_li_left">7</div>
								<div class="ins_li_right">
									<p class="lit_p1">店面选址、装修</p>
									<p class="lit_p2">
										总部对加盟者进行选址审核，为加盟者提供装修指导与设计指导。
									</p>
								</div>
							</li>
							<li class="ins_li flex1">
								<div class="ins_li_left">8</div>
								<div class="ins_li_right">
									<p class="lit_p1">货物配送</p>
									<p class="lit_p2">
										总部对物料配送提供帮助。
									</p>
								</div>
							</li>
							<li class="ins_li flex1">
								<div class="ins_li_left">9</div>
								<div class="ins_li_right">
									<p class="lit_p1">正式营业</p>
									<p class="lit_p2">
										总部持续关注加盟者的经营情况，并给予经营指导与帮助。
									</p>
								</div>
							</li>
						</ul>
					</div>
					<div class="concat_box flex1" data-aos="fade-up">
						<div class="cb_item">
							<p class="cb_sty1">申请加盟</p>
							<p class="cb_sty2">
								填写剑南春专卖店特许加盟申请表，按表内要求提交申请加盟
							</p>
							<p class="cb_sty3">
								<span>点击填写</span>
								<a @click="toApply">剑南春专卖店特许加盟申请表</a>
							</p>
							<p class="cb_sty2">
								风险提示：投资有风险，加盟需谨慎！
							</p>
						</div>
						<div class="cb_item ml_20">
							<p class="cb_sty1">联系方式</p>
							<p class="cb_sty2">联系电话：400-977-7777</p>
							<p class="cb_sty2">邮箱：hjfs@jnc.cn</p>
							<p class="cb_sty2">地址：四川·绵竹·春溢街52号</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="jp_phone" v-if="isPhone">
			<Header2 :searchShow="false" pageTitle="招商加盟"></Header2>
			<p class="jp_tit" data-aos="fade-up">招商加盟</p>
			<p class="jp_tit2" data-aos="fade-up">
				{ <span>与我们一起创造美好的未来</span> }
			</p>
			<div class="ins_box" data-aos="fade-up">
				<p class="ins_tit">剑南春专卖店申请须知：</p>
				<ul class="ins_ul">
					<li class="ins_li flex1">
						<div class="ins_li_left">1</div>
						<div class="ins_li_right">
							<p class="lit_p1">投资咨询</p>
							<p class="lit_p2">
								加盟者可以通过电话、微信留言、填写申请表等方式向总部初步了解项目信息。
							</p>
						</div>
					</li>
					<li class="ins_li flex1">
						<div class="ins_li_left">2</div>
						<div class="ins_li_right">
							<p class="lit_p1">专卖店试销经销商资质审核</p>
							<p class="lit_p2">
								总部对加盟者进行审核，确认加盟者的试销合作资格。
							</p>
						</div>
					</li>
					<li class="ins_li flex1">
						<div class="ins_li_left">3</div>
						<div class="ins_li_right">
							<p class="lit_p1">专卖店试销合同签订</p>
							<p class="lit_p2">
								双方确认考察无争议，签订专卖店试销合同。
							</p>
						</div>
					</li>
					<li class="ins_li flex1">
						<div class="ins_li_left">4</div>
						<div class="ins_li_right">
							<p class="lit_p1">销售考核</p>
							<p class="lit_p2">
								试销客户将接受为期 3-9 个月的销售考核。
							</p>
						</div>
					</li>
					<li class="ins_li flex1">
						<div class="ins_li_left">5</div>
						<div class="ins_li_right">
							<p class="lit_p1">资质评估</p>
							<p class="lit_p2">
								根据试销客户销售情况，审核专卖店经销商合作资格。
							</p>
						</div>
					</li>
					<li class="ins_li flex1">
						<div class="ins_li_left">6</div>
						<div class="ins_li_right">
							<p class="lit_p1">签订专卖店合同</p>
							<p class="lit_p2">
								双方确认考察结果无争议，正式签订专卖店合同。
							</p>
						</div>
					</li>
					<li class="ins_li flex1">
						<div class="ins_li_left">7</div>
						<div class="ins_li_right">
							<p class="lit_p1">店面选址、装修</p>
							<p class="lit_p2">
								总部对加盟者进行选址审核，为加盟者提供装修指导与设计指导。
							</p>
						</div>
					</li>
					<li class="ins_li flex1">
						<div class="ins_li_left">8</div>
						<div class="ins_li_right">
							<p class="lit_p1">货物配送</p>
							<p class="lit_p2">总部对物料配送提供帮助。</p>
						</div>
					</li>
					<li class="ins_li flex1">
						<div class="ins_li_left">9</div>
						<div class="ins_li_right">
							<p class="lit_p1">正式营业</p>
							<p class="lit_p2">
								总部持续关注加盟者的经营情况，并给予经营指导与帮助。
							</p>
						</div>
					</li>
				</ul>
			</div>
			<div class="contact2" data-aos="fade-up">
				<p class="con2_p1">联系方式</p>
				<p class="con2_p2">联系电话：400-977-7777</p>
				<p class="con2_p2">邮箱：hjfs@jnc.cn</p>
				<p class="con2_p2">地址：四川·绵竹·春溢街52号</p>
				<div class="con2_d1">
					<p class="con2_pd3">申请加盟</p>
					<p class="con2_pd4">
                        填写剑南春专卖店特许加盟申请表，按表内要求提交申请加盟
					</p>
                    <p class="con2_pd5">
                        <span>点击填写</span>
                        <span @click="toApply">剑南春专卖店特许加盟申请表</span>
                    </p>
				</div>
				<div class="con2_d1">
					<p class="con2_pd3">风险提示：</p>
					<p class="con2_pd4">投资有风险，加盟需谨慎！</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isPhone: this.$isMobile,
		};
	},
	created() { },
	methods: {
        toApply(){
            this.$router.push("/applyForm");
        }
    },
};
</script>

<style lang="scss">
.jp_tit {
	text-align: center;
	color: #c0494b;
	font-size: 36px;
	margin-bottom: 20px;
}
.join_page {
    @font-face {
        font-family: 'SourceHanSans';
        src: url('../../font/SourceHanSansCN-Regular.otf');
    }
    font-family: 'SourceHanSans';
	.jp_pc {
		width: 100%;
		padding: 50px 0 70px;
		min-height: 900px;
		background-image: url("../../images/bgimg3.png");
		box-sizing: border-box;
		.jp_box {
			background-position: bottom;
			background-repeat: no-repeat;
			background-image: url("../../images/join/jn_img1.png");
			padding: 80px 20px 74px;
			position: relative;
			.jp_con {
				max-width: 1280px;
                min-width: 900px;
				margin: 0 auto;
				.jp_tit2 {
					text-align: center;
					color: rgba(0, 0, 0, 0.4);
					font-size: 30px;
					margin-bottom: 26px;
					span {
						text-align: center;
						font-size: 30px;
						color: #000;
					}
				}
				.ins_box {
					margin: 0 -10px;
					padding: 32px 56px 20px;
					background-color: hsla(0, 0%, 100%, 0.3);
					.ins_tit {
						text-align: left;
						color: #202020;
						font-size: 22px;
					}
					.ins_ul {
						margin: 0 -70px;
						flex-wrap: wrap;
						.ins_li {
							width: 33.3%;
							padding: 0 45px;
							margin-top: 36px;
							align-items: flex-start;
							box-sizing: border-box;
							.ins_li_left {
								font-size: 36px;
								color: #c0494b;
								width: 36px;
							}
							.ins_li_right {
								padding-left: 12px;
								flex: 1;
								.lit_p1 {
									text-align: left;
									color: #202020;
									font-size: 22px;
									margin-bottom: 10px;
								}
								.lit_p2 {
									text-align: left;
									color: #777;
									font-size: 16px;
									line-height: 1.8;
									height: 84px;
								}
							}
						}
					}
				}
				.concat_box {
					margin: 20px -10px;
					.cb_item {
						box-sizing: border-box;
						padding: 60px 55px;
						background-color: hsla(0, 0%, 100%, 0.3);
						width: 50%;
						height: 390px;
						.cb_sty1 {
							margin-bottom: 30px;
							color: #333;
							font-size: 24px;
							font-weight: 700;
							text-align: left;
						}
						.cb_sty2 {
							text-align: left;
							color: #333;
							font-size: 18px;
							line-height: 2;
							margin: 15px 0;
						}
						.cb_sty3 {
							text-align: left;
							padding: 12px;
							margin-top: 10px;
							span {
								display: inline-block;
								color: #333;
								font-size: 18px;
								font-weight: bold;
								height: 47px;
								line-height: 47px;
								margin-right: 13px;
							}
							a {
								display: inline-block;
								color: #fff;
								background-color: #d43235;
								padding: 0 23px;
								border-radius: 47px;
								font-size: 18px;
								font-weight: 700;
								height: 47px;
								line-height: 47px;
								margin-right: 13px;
                                cursor: pointer;
							}
						}
					}
				}
			}
		}
	}
	.jp_phone {
		background: url("../../images/join/bg1.png") no-repeat bottom;
		background-size: 100% auto;
		padding: 1.6rem 0.53rem 3rem;
		.jp_tit {
			text-align: center;
			color: #c0494b;
			font-size: 19px;
			margin-bottom: 0.21rem;
		}
		.jp_tit2 {
			text-align: center;
			color: #666;
			font-size: 16px;
			margin-bottom: 0.45rem;
		}
		.ins_box {
			background-color: hsla(0, 0%, 100%, 0.5);
			margin-bottom: 0.4rem;
			padding: 0.45rem 0.51rem 0.45rem 0;
			box-sizing: border-box;
			.ins_tit {
				color: #484848;
				font-size: 14px;
				padding-left: 0.51rem;
				text-align: left;
				box-sizing: border-box;
			}
			.ins_ul {
				.ins_li {
					padding: 0.48rem 0;
					align-items: flex-start;
					border-top: 1px solid #dfdfdf;
					&:nth-child(1) {
						border: none;
					}
					.ins_li_left {
						display: block;
						width: 1.41rem;
						color: #c0494b;
						font-size: 28px;
						font-weight: 700;
						line-height: 1;
						text-align: center;
					}
					.ins_li_right {
						overflow: hidden;
						padding-left: 1px;
						flex: 1;
						.lit_p1 {
							color: #333;
							font-size: 17px;
							font-weight: 700;
							margin-bottom: 0.27rem;
							text-align: left;
						}
						.lit_p2 {
							color: #666;
							font-size: 15px;
							line-height: 1.7;
							text-align: left;
						}
					}
				}
			}
		}
		.contact2 {
			background-color: hsla(0, 0%, 100%, 0.6);
			padding: 0.53rem;
			color: #333;
			font-size: 15px;
			line-height: 1.7;
			.con2_p1 {
				margin-bottom: 0.3rem;
				font-size: 17px;
				color: #333;
				font-weight: 700;
				text-align: left;
			}
			.con2_p2 {
				color: #333;
				font-size: 15px;
				line-height: 1.7;
				text-align: left;
			}
			.con2_d1 {
				font-size: 13px;
				color: #333;
				line-height: 1.7;
				margin-top: 0.267rem;
				.con2_pd3 {
					color: #d43235;
					margin-bottom: 0.1rem;
					text-align: left;
				}
				.con2_pd4 {
					font-size: 13px;
					color: #333;
					line-height: 1.7;
					text-align: left;
				}
                .con2_pd5{
                    margin: 0.3rem 0;
                    text-align: left;
                    span{
                        &:nth-child(1){
                            
                        }
                        &:nth-child(2){
                            color: #fff;
                            background-color: #d43235;
                            margin-left: 0.35rem;
                            padding: 0.3rem 0.4rem;
                            border-radius: 0.5rem;
                            font-size: 0.36rem;
                        }
                    }
                }
			}
		}
	}
}
</style>